import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

export const StyledBox = styled(Box)(({ theme }) => ({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: theme.spacing(4),
  height: theme.spacing(1),
  backgroundColor: theme.palette['Colors/Text/text-placeholder_subtle'],
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '&, & .MuiInputBase-root': {
    height: 'initial',
  },

  '& input': {
    ...theme.typography.displaySm,
    textAlign: 'center',
  },
}));
